<template>
  <v-row>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="detail.items" dense sort-by="invoiceDate">
        <template v-slot:item.no="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.invoiceAmount="{ item }">
          {{ formatPrice(item.invoiceAmount) }}
        </template>
        <template v-slot:item.ppn="{ item }">
          {{ formatPrice(item.ppn) }}
        </template>
        <template v-slot:item.debit="{ item }">
          {{ formatPrice(item.debit) }}
        </template>
        <template v-slot:item.credit="{ item }">
          {{ formatPrice(item.credit) }}
        </template>
        <template v-slot:item.balance="{ item }">
          {{ formatPrice(item.balance) }}
        </template>
      </v-data-table>
    </v-col>
    <v-col cols="12">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="12" md="6" xl="2">
          <v-card outlined>
            <v-card-title class="py-0">Total Invoice</v-card-title>
            <v-card-text class="text-right mt-3">
              <span>{{ formatPrice(detail.total) }}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="6" xl="2">
          <v-card outlined>
            <v-card-title class="py-0">Total GL</v-card-title>
            <v-card-text class="text-right mt-3">
              <span>{{ formatPrice(detail.totalAmountJournal) }}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="6" xl="2">
          <v-card outlined>
            <v-card-title class="py-0">Total Different</v-card-title>
            <v-card-text class="text-right mt-3">
              <span>{{ formatPrice(detail.total - detail.totalAmountJournal) }}</span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "report-reconciliation-dp-ap",
  props: {
    detail: Object,
    type: String,
  },
  data() {
    return {
      headers: [
        {
          id: 1,
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 2,
          text: "Invoice #",
          value: "invoiceNumber",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 2,
          text: "Invoice Date",
          value: "invoiceDate",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "PO#",
          value: "poNumber",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Vendor",
          value: "vendor",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Persentase",
          value: "percentage",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Invoice Amount",
          value: "invoiceAmount",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "PPN",
          value: "ppn",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Debit",
          value: "debit",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Credit",
          value: "credit",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Balance",
          value: "balance",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style></style>
